import React from 'react';
import {Button, Result} from "antd";

const Error = ({status,title,subtitle}) => {
    return (
        <Result
            status={status}
            title={title}
            subTitle={subtitle}
            extra={<Button href="/" type="primary">Anasayfaya Dön</Button>}
        />
    );
};

export default Error;
